<template>
    <slot
        :has-items="hasItems"
        :items="items"
        :active-item="activeItem"
        :extra-fields="extraFields"
        :enter="enter"
        :clear="clear"
        :move-up="moveUp"
        :move-down="moveDown"
        :fields="fields"
    />
</template>

<script>
import axios from 'axios';
import debounce from "../../helpers/debounce";

export default {
    name: 'AutoComplete',
    props: {
        source: {type: String, required: true},
        bucket: {type: String, required: true},
        extraFields: {type: Object, default: () => ({})},
    },

    data() {
        return {
            fields: {
                query: '',
            },
            items: [],
            activeIndex: null,
        };
    },

    watch: {
        'fields.query': function() {
            this.debouncedLoad();
        },
    },

    created() {
        this.debouncedLoad = debounce(this.load, 150);
    },

    methods: {
        async load() {
            if (!(this.fields.query && this.fields.query.length > 1)) {
                this.items = [];
                this.activeIndex = null;
                return;
            }

            const url = new URL(this.source);
            Object.entries(this.extraFields).forEach(([key, value]) => url.searchParams.set(key, value));
            url.searchParams.set('q', this.fields.query);

            const response = await axios.get(url.toString());

            this.items = response.data.data[this.bucket]?.items || [];
            this.activeIndex = null;
        },

        clear() {
            this.items = [];
        },

        enter(e) {
            if (this.activeItem === null) {
                return;
            }

            e.preventDefault();
            window.location = this.activeItem.link;
        },

        moveUp() {
            if (this.hasItems && this.activeIndex > 0) {
                --this.activeIndex;
            }
        },

        moveDown() {
            if (this.hasItems) {
                if (this.activeIndex === null) {
                    this.activeIndex = 0;
                } else if (this.activeIndex < (this.items.length - 1)) {
                    ++this.activeIndex;
                }
            }
        },
    },

    computed: {
        hasItems() {
            return this.items.length;
        },

        activeItem() {
            if (this.activeIndex === null) {
                return null;
            }
            return this.items[this.activeIndex];
        },
    },
}
</script>
